import api from '@/api'
import {
  SET_FEEDBACK_LIST,
  SET_FEEDBACK_LIST_PAGE_COUNT,
  SET_FEEDBACK_LIST_PAGE_SIZE,
  SET_FEEDBACK_LIST_PAGE_TOTAL,
} from './mutation-types'
import { checkUserName } from '@/views/User/utils'

const state = {
  list: [],
  pageSize: 20,
  pageCount: 0,
  total: 0,
}

const mutations = {
  [SET_FEEDBACK_LIST](state, payload) {
    state.list = payload
  },
  [SET_FEEDBACK_LIST_PAGE_COUNT](state, payload) {
    state.pageCount = payload
  },
  [SET_FEEDBACK_LIST_PAGE_SIZE](state, payload) {
    state.pageSize = payload
  },
  [SET_FEEDBACK_LIST_PAGE_TOTAL](state, payload) {
    state.total = payload
  },
}
const actions = {
  async getFeedbackList({ state, commit, dispatch }, payload) {
    try {
      const {
        data,
        code,
      } = await api.feedbackApi.getPlatformFeedback(payload)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = payload
          dispatch('getFeedbackList', {
            ...other,
            userId,
          })
        },
      })
      const { items, pageCount, total } = data
      if (payload.type === 'scrollAdd') {
        commit(SET_FEEDBACK_LIST, [...state.noticeList, ...items])
      } else {
        commit(SET_FEEDBACK_LIST, items)
      }
      commit(SET_FEEDBACK_LIST_PAGE_COUNT, pageCount)
      commit(SET_FEEDBACK_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_FEEDBACK_LIST, [])
      commit(SET_FEEDBACK_LIST_PAGE_COUNT, 0)
    }
  },
  updatePageSize({ commit }, payload) {
    commit(SET_FEEDBACK_LIST_PAGE_SIZE, payload)
  },
  refreshClientPromotionList ({dispatch}) {
    dispatch('getFeedbackList', {pageNum: 1, pageSize: state.pageSize, type: 'refresh'})
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
